'use client'

import { cn } from '@/lib/utils'
import type { DecorationFieldProps } from './types'

/**
 * Section heading. Decoration block — renders identically in preview and
 * live so the canvas matches the respondent view. An empty heading shows a
 * faint placeholder in preview so the block stays visible/selectable.
 */
export function SectionHeaderField({ props, mode }: DecorationFieldProps<'SectionHeader'>) {
  const level = props.level ?? 2
  const Tag = `h${level}` as 'h1' | 'h2' | 'h3'
  const sizeClass = level === 1 ? 'text-2xl' : level === 2 ? 'text-xl' : 'text-lg'
  const text = typeof props.text === 'string' ? props.text.trim() : ''
  return (
    <Tag className={cn('font-semibold', sizeClass, !text && 'text-muted-foreground')}>
      {text || (mode === 'preview' ? 'Section heading' : '')}
    </Tag>
  )
}
